/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import React, {useState} from "react";
import {Link} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import bgImage from "assets/images/bg_auth.jpg";
import {Form, Formik} from "formik";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import MDSnackbar from "../../../components/MDSnackbar";
import Divider from "@mui/material/Divider";
import IllustrationLayout from "../components/IllustrationLayout";
import SignInForm from "./components/SignInForm";
import {useSignIn} from "./useSignIn";

function SignIn() {

    const { snackbarConfig, show, initialValues, formId, formField, validations, toggleSnackbar, submitForm } = useSignIn();

    return (
        <IllustrationLayout
            title="Inicio de Sesión"
            description="Ingresa tus credenciales de acceso."
            illustration={bgImage}
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validations}
                onSubmit={submitForm}
            >
                {({values, errors, touched, isSubmitting}) => (
                    <Form id={formId} autoComplete="off">
                        <SignInForm formData={{values, touched, formField, errors}}/>
                        <MDBox mt={4} mb={1}>
                            <MDButton
                                disabled={isSubmitting}
                                variant="gradient"
                                color="secondary"
                                size="large"
                                fullWidth
                                type="submit"
                            >
                                {isSubmitting && <CircularProgress size={18} color="white" sx={{marginRight: 1}}/>}
                                Iniciar
                            </MDButton>
                        </MDBox>
                        <Divider />
                        <MDBox mt={2} textAlign="center">
                            <MDTypography variant="button" color="text">
                                Olvidaste tu contraseña?{" "}
                                <MDTypography
                                    component={Link}
                                    to="/autenticacion/recuperar"
                                    variant="button"
                                    color="secondary"
                                    fontWeight="medium"
                                    textGradient
                                >
                                    Recuperar
                                </MDTypography>
                            </MDTypography>
                        </MDBox>
                    </Form>
                )}
            </Formik>
            <MDSnackbar
                color={snackbarConfig.color}
                icon={snackbarConfig.icon}
                title={snackbarConfig.title}
                content={snackbarConfig.message}
                dateTime=""
                autoHideDuration={3000}
                open={show}
                close={toggleSnackbar}
            />
        </IllustrationLayout>
    );
}

export default SignIn;
